module.exports = __webpack_public_path__ + "img/Group(11).baa1e980.svg";